// React
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Containers Injection
import { ReportsInjection } from '../../containers/reportsInjection';

// View
import { ReportsPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';

export const Reports = () => {
  const { getReports, reports } = ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  useEffect(() => {
    getReports();
  }, []);

  return (
    <ReportsPage
      api={api}
      history={history}
      reports={reports}
      setLoading={setLoading}
      toggleLoading={toggleLoading}
    />
  );
};
